import { EBrowserStorageType } from '@/core/apis/browser_storage_api/browser_storage_api_types';
import { CookieLibrary } from '@/core/apis/browser_storage_api/cookie_lib/cookie_lib';
import IdentityApiService from '@/core/apis/identity_api/identity_api';
import { PatchUpdateUpdateSessionIdMappingRequest } from '@/core/apis/identity_api/types';
import { StorageHandler } from '@/core/data_handlers/storage_handler';
import { getCheckoutAndCartTokens } from '@/shared/__ui_helper';
import { EBundleName } from '@/sources';

import { ShopifyCartApi } from '../shpfy_api/shpfy_cart_api';

export const ShopifyCartTokenSync = {
  cartTokenStorage: new StorageHandler<string>(
    'cartToken',
    '',
    EBrowserStorageType.LOCALSTORAGE,
  ),
  checkoutTokenStorage: new StorageHandler<string>(
    'checkoutToken',
    '',
    EBrowserStorageType.LOCALSTORAGE,
  ),

  getCartTokenCookie: (): string =>
    CookieLibrary.get('cart')?.split('?')[0] || '',

  getCurrentCartToken: async (): Promise<string> => {
    let cartToken = ShopifyCartTokenSync.getCartTokenCookie();
    if (!cartToken && EBundleName.SHOPIFY_CUSTOM_PIXEL) {
      const currentCart = await ShopifyCartApi.fetchCart();
      cartToken = currentCart?.token || '';
    }
    return cartToken;
  },

  syncCartAndCheckoutToken: async (sessionId: string): Promise<boolean> => {
    const cachedCartToken = ShopifyCartTokenSync.cartTokenStorage.get();
    const cachedCheckoutToken = ShopifyCartTokenSync.checkoutTokenStorage.get();

    const { cartToken, checkoutToken } = getCheckoutAndCartTokens();

    if (
      (cartToken && cartToken !== cachedCartToken) ||
      (checkoutToken && checkoutToken !== cachedCheckoutToken)
    ) {
      ShopifyCartTokenSync.updateStorageAndIdentity(
        sessionId,
        cartToken || '',
        checkoutToken || '',
        cachedCartToken,
        cachedCheckoutToken,
      );
      return true;
    }
    return false;
  },

  updateStorageAndIdentity: (
    sessionId: string,
    cartToken: string,
    checkoutToken: string,
    cachedCartToken: string,
    cachedCheckoutToken: string,
  ): void => {
    const request: Partial<PatchUpdateUpdateSessionIdMappingRequest> = {
      sid: sessionId,
    };
    let shouldUpdate = false;
    if (cartToken && cartToken !== cachedCartToken) {
      request.cartToken = cartToken;
      ShopifyCartTokenSync.cartTokenStorage.set(cartToken);
      shouldUpdate = true;
    }
    if (checkoutToken && checkoutToken !== cachedCheckoutToken) {
      request.checkoutToken = checkoutToken;
      ShopifyCartTokenSync.checkoutTokenStorage.set(checkoutToken);
      shouldUpdate = true;
    }

    if (shouldUpdate) {
      // eslint-disable-next-line @typescript-eslint/no-floating-promises
      IdentityApiService.updateSessionIdMapping(
        request as PatchUpdateUpdateSessionIdMappingRequest,
      );
    }
  },
};
